import { createTracker } from 'usage-tracker';
import events from 'ui-memberships-settings-lib/events.yaml';
import { CategoryIdToAccessControlContentType } from '../constants/ContentTypes';
import { PublicAccessRuleTypeToAccessControl } from '../constants/AccessControlTypes';
export const usageTracker = createTracker({
  events,
  properties: {
    namespace: 'memberships'
  }
});
export const trackViewEvent = eventKey => {
  usageTracker.track(eventKey);
};
export const trackAccessControlInteractions = (properties = {}) => {
  usageTracker.track('contentAccessControl', properties);
};
export const trackAccessControlInteractionsBeforeUnload = (properties = {}) => {
  const beforeUnloadTracker = usageTracker.clone({
    isBeforeUnload: true
  });
  beforeUnloadTracker.track('contentAccessControl', properties);
};
export const trackContentAccessControlModalPanelSave = ({
  contentCategoryId,
  contentCount,
  publicAccessRuleType
}) => {
  const accessControlType = PublicAccessRuleTypeToAccessControl[publicAccessRuleType];
  const accessControlContentType = CategoryIdToAccessControlContentType[contentCategoryId];
  trackAccessControlInteractions({
    action: 'save access control settings',
    access: accessControlType,
    contentType: accessControlContentType,
    isBulk: contentCount > 1
  });
};